if(document.querySelectorAll('.image-carousel__container').length) {
  try {
    var swiper = new Swiper('.image-carousel__container', {
      slidesPerView: 1,
      spaceBetween: 0,
      direction: 'horizontal',
      effect: 'fade',
      fadeEffect: { crossFade: true },

      pagination: {
        el: ".image-pagination",
        type: "fraction",
      },
      navigation: {
        nextEl: ".image-next",
        prevEl: ".image-prev",
      },
    });
  } catch (e) {
    console.log(e);
  }
}